import img1 from "../../assets/Images/Banquet Setup/Banquet Setup Occasions.png"
import img2 from "../../assets/Images/Banquet Setup/add occassion popup.png"
export default function Occasions() {
    return (
        <section id="occasions" className="space-y-16">

            {/* SECTION TITLE */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    3. Occasions
                </h1>
                <p className="text-md text-slate-600 max-w-3xl">
                    Occasions define the type of event being booked, such as Mehndi,
                    Barat, Valima, Nikah, or corporate and private gatherings.
                </p>


                {/* OVERVIEW */}
                <section className="bg-white border-l border-[#C9A24E] p-4 mt-2">
                    <h2 className="text-lg font-semibold mb-3">
                        Overview
                    </h2>
                    <p className="text-slate-600 text-sm">
                        The Occasions module serves as a master list of event types available
                        within EventFlow. These occasions are used across bookings,
                        estimates, calendars, and reports to categorize events correctly.
                    </p>
                </section>
            </section>

            {/* OCCASION LIST */}
            <section className="">
                <div>
                    <h3 className="font-semibold mb-2">
                        Occasion List
                    </h3>

                    <p className="text-slate-600 mb-4">
                        When the Occasions module is opened, a table displays all configured
                        occasion names along with their current status.
                    </p>

                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Occasion Name (e.g. Mehndi, Valima, Engagement)</li>
                        <li>Active / Inactive status</li>
                        <li>Edit option</li>
                        <li>Status toggle control</li>
                    </ul>
                </div>

                <div className=" rounded-lg p-4 ">
                    <img src={img1} alt="" />
                </div>
            </section>

            {/* ADD OCCASION */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Adding a New Occasion
                </h3>

                <p className="text-slate-600 mb-4">
                    Clicking the <strong>Add New Occasion</strong> button opens a popup
                    form for creating a new event type.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>
                        <strong>Occasion Name:</strong> Enter the name of the event type
                    </li>
                </ul>

                <p className="text-slate-600 mt-3">
                    Once saved, the new occasion becomes immediately available in
                    bookings and estimates.
                </p>

                <div className="rounded-lg p-4 mt-4 flex justify-center items-center">
                    <img src={img2} alt="" className="w-[500px] h-auto" />
                </div>
            </section>

            {/* EDIT OCCASION */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Editing an Occasion
                </h3>

                <p className="text-slate-600 mb-4">
                    Clicking the <strong>Edit</strong> action opens the same popup with the
                    existing occasion name auto-filled.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Modify the occasion name</li>
                    <li>Correct spelling or naming conventions</li>
                </ul>

                <p className="text-slate-600 mt-3">
                    Updates apply instantly and reflect across all modules using the
                    occasion.
                </p>
            </section>

            {/* STATUS TOGGLE */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Activating & Deactivating Occasions
                </h3>

                <p className="text-slate-600 mb-4">
                    Each occasion includes a toggle control to activate or deactivate it
                    without deleting historical data.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Active occasions appear in booking forms</li>
                    <li>Inactive occasions are hidden from selection</li>
                    <li>Existing records remain unchanged</li>
                </ul>

                <p className="text-slate-600 mt-3">
                    A confirmation toast message appears when an occasion is activated or
                    deactivated (e.g. <em>Occasion Activated</em>, <em>Occasion Deactivated</em>).
                </p>
            </section>

            {/* WHY IMPORTANT */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Why Occasion Management Matters
                </h3>

                <p className="text-slate-600 max-w-3xl">
                    Properly managed occasions improve reporting accuracy, standardize
                    event classification, and ensure consistency across bookings,
                    calendars, and financial summaries.
                </p>
            </section>

        </section>
    );
}
